import React, { useContext } from "react";
import { ThemeContext } from "../lib/main-context";
import { useTranslation } from "../i18n/TranslationProvider";
import { translateTrigger as translateTriggerName } from "../i18n/translateData";

import theme from "../index.scss";
import ReactECharts from 'echarts-for-react';

const TriggerBarChart = ({ data, userName, splitView }) => {
    const { dark } = useContext(ThemeContext);
    const { t } = useTranslation();

    // Display only — counts are keyed by the English trigger names
    const translateTrigger = (name) => translateTriggerName(t, name);

    const calNumOfEachTriggerFactor = (data) => {
        const count = {};
        data.forEach((item) => {
            const elements = item.description.split(", ");
            elements.forEach((element) => {
                count[element] = (count[element] || 0) + 1;
            });
        });
        const result = Object.entries(count).map(([name, value]) => ({ name, value }));
        const sorted = result.sort((a, b) => b.value - a.value);
        const top5 = sorted.slice(0, 5);
        return top5
    }

    const top5 = calNumOfEachTriggerFactor(data)
    const option = {
        title: {
            text: t("dashboard.topTriggers"),
            left: 'center',
            textStyle: {
                fontSize: '1.2rem',
                color: dark ? theme.darkModeText : theme.black,
            },
            subtext: top5.length == 0 ? t("dashboard.noTrackingData.0") : `${splitView ? `(${userName})` : ""}`,
            subtextStyle: {
                fontSize: '1.3rem',
                color: dark ? theme.darkModeText : theme.primary,
            },
        },
        tooltip: {
            trigger: 'item',
        },
        xAxis: {
            type: 'value',
            axisLabel: {
                fontSize: 16,
                color: dark ? theme.darkModeText : theme.black,
            },
        },
        grid: {
            left: '5%',
            containLabel: true
        },
        yAxis: {
            type: 'category',
            axisLabel: {
                fontSize: 16,
                color: dark ? theme.darkModeText : theme.black,
            },
            data: top5.map(item => translateTrigger(item.name)).reverse()
        },
        series: [
            {
                data: top5.map(item => item.value).reverse(),
                type: 'bar'
            }
        ]
    };

    return (
        <ReactECharts option={option} style={{ minHeight: "25vh" }} />
    )
}

export default TriggerBarChart;